<template>
  <main-content>
    <transactions-report-filter
        :action="filterAction"
        :exportExcel="exportToExcel"
    >
    </transactions-report-filter>
    <div>
      <kt-row>
        <kt-col lg="3" md="3" xs="12">
          <div class="kt-portlet">
            <div class="kt-portlet__body" style="color: black; background-color: #fff">
              <div class="text-center p-1">
                <h6> {{ $t('label.statements_from') }}  {{ my_statements.from_date}}</h6>
              </div>
              <div class="text-center pt-1">
                <h6> {{ $t('label.statements_to') }}  {{ my_statements.to_date}}</h6>
              </div>
            </div>
          </div>
        </kt-col>
        <kt-col lg="3" md="3" xs="12">
          <div class="kt-portlet">
            <div class="kt-portlet__body" style="color: black; background-color: #fff">
              <h6> {{ $t('label.terminal_title') }}</h6>
              <div class="text-center">
                <h4 class="fix-margin">
                  {{ my_statements.persian_name }}
                </h4>
              </div>
            </div>
          </div>
        </kt-col>
        <kt-col lg="3" md="3" xs="12">
          <div class="kt-portlet">
            <div class="kt-portlet__body" style="color: black; background-color: #fff">
              <h6> {{ $t('label.total_transactions') }}</h6>
              <div class="text-center">
                <h4 class="fix-margin">
                  {{  my_statements.total_statements }}
                  <span style="font-size: 1.5rem">
                                        {{ ' ' + $t('currency.rial')}}
                                    </span>
                </h4>
              </div>
            </div>
          </div>
        </kt-col>
        <kt-col lg="3" md="3" xs="12">
          <div class="kt-portlet">
            <div class="kt-portlet__body" style="color: black; background-color: #fff">
              <h6>{{ $t('label.succeeded_transactions_number') }}</h6>
              <div class="text-center">
                <h4 class="fix-margin">
                  {{my_statements.total_success_transactions }}
                </h4>
              </div>
            </div>
          </div>
        </kt-col>
      </kt-row>
    </div>
    <div>
      <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
  </main-content>
</template>

<script>
import statementsReportFilter from "@/views/gateway/components/statements-report-filter.vue";
import toastr from "toastr";
import columns from "@/views/gateway/datatable/statements-report-columns";
import {mapGetters} from "vuex";
import $ from "jquery";
import axios from "axios";
import {KTApp} from "@/plugins/core/app";
import mainContent from "@/components/main-content.vue";
import {StarShopApiUrl} from "@/common/api.service";
import { AuthorizationHeader } from '@/common/jwt.service'
import store from "@/store";
import { i18n } from '@/plugins/i18n'


export default {
  name: "Offline",
  props: ['hashid'],
  components: {
    mainContent,
    'transactions-report-filter': statementsReportFilter
  },
  data() {
    return {
      headerAction: {
        left: '10px',
        top: '10px',
        position: 'absolute'
      },
      query: {
        'shop_type': 'dedicated',
        psp:  this.$route.query.psp
      },
      gateway_id: this.$route.params.hashid,
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
    datatableProps() {
      const self = this
      return {
        id: "datatable",
        data: {
          type: 'remote',
          source: {
            read: {
              url: StarShopApiUrl.path(`collective/admin/get-offline-transactions/${this.gateway_id}`),
              method: 'GET',
              headers: AuthorizationHeader,
              map: (res) => {
                return res.data.data.data
              },
              params: {
                query: this.query,
              },
              success: function (res) {
                let params = {
                  hashid: res.data.data.shop_id,
                  query: {
                    psp: self.$route.query.psp
                  }
                }
                store.dispatch('gateway/fetchTransactionOfflineReport', params)
              },
            }
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        pagination: false,
        sortable: true,
        columns: columns,

      }
    },
    ...mapGetters('gateway', [
      'status', 'my_statements'
    ]),
  },
  methods: {
    updateReport(e, query) {
      query.reportUpdate = true
      query.psp = this.$route.query.psp
      this.query = query
      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload()
      }
    },
    exportToExcel(e, query){
      let btn = $('#export_psp_transations_btn')
      KTApp.progress(btn)
      query.shop_type = "dedicated"
      query.psp = this.$route.query.psp
      this.query = query
      axios({
        url: StarShopApiUrl.path(`collective/admin/export-offline-transactions-report/${this.gateway_id}`),
        method: 'GET',
        params: this.query,
        responseType: 'blob',
      }).then((response) => {
        KTApp.unprogress(btn);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'statements.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(({response}) => {
        this.toastr.error(i18n.t('message.an_error_accord'))
        KTApp.unprogress(btn)
      })
    },
    filterAction(e, query) {
      query.reportUpdate = false
      query.shop_type = "dedicated"
      query.psp = this.$route.query.psp
      if (query.from_date) {
        var from_date = new Date(query.from_date);
      }
      if (query.to_date) {
        var to_date = new Date(query.to_date);
      }
      if (to_date && from_date && from_date > to_date) {
        this.toastr.error(i18n.t('message.error_my_statements'))
        return;
      }
      this.query = query
      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload()
      }
    },

  },
}
</script>

<style scoped>

</style>